export const components = {
    'a[data-is=smooth-scroll]': 'smooth-scroll',
    'account-settings': 'account-settings/index',
    'astrology-compatibility': 'compatibility/astrology',
    'astrology-compatibility-report': 'reports/astrology-compatibility-report/index',
    'astrology-report': 'reports/astrology',
    'birthday-select': 'birthday-select',
    'catalog-content': 'catalog/content',
    'catalog-inputs': 'catalog/inputs',
    'chinese-zodiac-signs': 'chinese-zodiac-signs',
    'chinese-zodiac-sign-datepicker': 'chinese-zodiac-sign-datepicker',
    'compatibility-chooser': 'compatibility/chooser',
    'content-styles': 'content-styles/index',
    'cordial': 'cordial',
    'daily-hexagram': 'daily/hexagram/index',
    'daily-horoscope': 'daily/horoscope',
    'daily-links': 'daily/links',
    'daily-number': 'daily/number',
    'daily-tarot-card': 'daily/tarot-card/index',
    'date-picker': 'date-picker',
    'desktop-nav-dropdown': 'nav/desktop-dropdown',
    'desktop-zodiac-dropdown': 'desktop-zodiac-dropdown',
    'dfp': 'dfp',
    'essential-birth-report': 'reports/essential-birth-report/index',
    'eyeota': 'eyeota',
    'feedback-tab': 'feedback-tab',
    'forums-register': 'user/forums/register',
    'forums-signup': 'user/forums/signup',
    'ga-events': 'ga-events',
    'hexagram-content': 'content/hexagram',
    'i-ching-interps': 'reports/i-ching-interps',
    'i-ching-reading': 'i-ching-reading',
    'karmacoin-store': 'karmacoin-store/index',
    'keen': 'keen',
    'logged-in': 'logged-in',
    'logged-out': 'logged-out',
    'member-email-preferences': 'member/email-preferences',
    'member-email-unsubscribe': 'member/email-unsubscribe',
    'mobile-nav-dropdown': 'nav/mobile-dropdown',
    'mobile-zodiac-dropdown': 'mobile-zodiac-dropdown',
    'modal': 'modals/index',
    'moon-phase': 'moon-phase',
    'newsletter': 'newsletter/index',
    'numerology-report': 'reports/numerology',
    'password-reset': 'member/password-reset',
    'password-reset-set': 'member/password-reset-set',
    'planet-tracker': 'planet-tracker',
    'policy-consent': 'policy-consent',
    'product-carousel': 'product-carousel',
    'product-message': 'product-message',
    'product-teeup': 'product-teeup',
    'profiles-manager': 'member/profiles/manager',
    'promo-message': 'promo-message',
    'promo-message-preview': 'promo-message-preview',
    'promoted-content': 'content/promoted',
    'sale-message': 'sale-message',
    'service-contact-form': 'service-contact-form',
    'subscription-teeup': 'teeups/subscription',
    'tarot-card-browser': 'tarot/card-browser',
    'tarot-interps': 'tarot/tarot-interps',
    'tarot-reading': 'tarot/readings/tarot-reading',
    'tarot-report-button': 'tarot/report-button',
    'top-bar': 'top-bar',
    'top-nav': 'nav/top',
    'upsell-button': 'upsell-button',
    'user': 'user/index',
    'vip-nav': 'nav/vip',
    'vip-profile-form': 'vip/profile-form',
    'vip-transits-list': 'vip/transits-list',
    'weekly-love-horoscope': 'weekly/love-horoscope',
    'yearly-forecast-transits': 'reports/yearly-forecast-transits',
    'zodiac-sign-picker': 'zodiac-sign-picker',
};